import axiosInstance from '../../config/AxiosConfig'
import {BACKEND_ENDPOINT} from '../../Constants'

const HEALTH_RECORD_PATH = 'healthRecord'
const HEALTH_RECORD_ACTIVITIES_PATH = 'healthRecord/activity'

//#region Health Record

export function getPageHealthRecords(
    userId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${HEALTH_RECORD_PATH}/getPage`,
            filterRequest,
            {
                params: {
                    userId,
                    pageNumber,
                    pageRows,
                    sortField,
                    sortOrder,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function getLatestRecord(userId, id) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${HEALTH_RECORD_PATH}/getLatestRecord`,
            null,
            {
                params: {userId, id},
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function getLastRecords(userId, id, typeCategory) {
    // Get most 7 days before the current date
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${HEALTH_RECORD_PATH}/getLastRecords`,
            null,
            {
                params: {userId, id, typeCategory},
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function getRecordsInDay(userId, id, date, type) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${HEALTH_RECORD_PATH}/getRecordsInDay`,
            null,
            {
                params: {userId, id, date, type},
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region Activities
export function getPageActivities(
    userId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${HEALTH_RECORD_ACTIVITIES_PATH}/getPage`,
            filterRequest,
            {
                params: {
                    userId,
                    pageNumber,
                    pageRows,
                    sortField,
                    sortOrder,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion
